export const VERSION = {
  PROD: 'V. 3.2.0',
  QA: 'V. 3.19.3 (QA)',
}
